import { FaultFieldMapping } from '../fault-field-mapping/fault-field-mapping';

export class TileLayout {
  hasImage = false;
  captionProperties: FaultFieldMapping[] = [];
  viewProperties: FaultFieldMapping[] = [];
}
